import React from 'react';
import PropTypes from 'prop-types';

import DsDropdownList from '../ds/molecules/DropdownList';
import '../../static/less/global/forms.less';

class TimePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
      timeFormatOptions: [
        { name: 'am', code: 'am' },
        { name: 'pm', code: 'pm' },
      ],
      hourOptions: [
        { name: '00', code: '00' },
        { name: '01', code: '01' },
        { name: '02', code: '02' },
        { name: '03', code: '03' },
        { name: '04', code: '04' },
        { name: '05', code: '05' },
        { name: '06', code: '06' },
        { name: '07', code: '07' },
        { name: '08', code: '08' },
        { name: '09', code: '09' },
        { name: '10', code: '10' },
        { name: '11', code: '11' },
        { name: '12', code: '12' },
      ],
      minuteOptions: [
        { name: '00', code: '00' },
        { name: '05', code: '05' },
        { name: '10', code: '10' },
        { name: '15', code: '15' },
        { name: '20', code: '20' },
        { name: '25', code: '25' },
        { name: '30', code: '30' },
        { name: '35', code: '35' },
        { name: '40', code: '40' },
        { name: '45', code: '45' },
        { name: '50', code: '50' },
        { name: '55', code: '55' },
      ],
      hourSelected: props.selectedTime.hour,
      minuteSelected: props.selectedTime.minute,
      timeFormatSelected: props.selectedTime.timeFormat,
      timeOption: Array.from(Array(24).keys()).map(
        // eslint-disable-next-line prefer-template
        (x) => ({ code: ('0' + x).slice(-2) + ':00', name: ('0' + x).slice(-2) + ':00' })),
    };
  }

  variantStyles(hasBorder) {
    const style = hasBorder && 'border-2 border-extra-grey h-7 mx-1';
    return `${style} time-picker`;
  }

  renderOneField() {
    return (
      <React.Fragment>
        <DsDropdownList
          className="h-7 mx-2 w-1/2 border-2 border-extra-grey time-picker"
          initialId={[]}
          items={this.state.timeOption}
          onChange={(name) => this.props.onChange('hourMinute', name, 'oneField')}
        />
      </React.Fragment>
    );
  }

  renderThreeFields() {
    const type = this.props.roundtripSelector;
    const { hasBorder, destination } = this.props;

    return (
      <React.Fragment>
        <DsDropdownList
          className={this.variantStyles(hasBorder)}
          required
          initialId={this.state.hourSelected}
          items={this.state.hourOptions}
          onChange={(name) => this.props.onChange('hour', name, destination, type)}
        />
        <span className='time-dots'>:</span>
        <DsDropdownList
          className={this.variantStyles(hasBorder)}
          initialId={this.state.minuteSelected}
          items={this.state.minuteOptions}
          onChange={(name) => this.props.onChange('minute', name, destination, type)}
        />
        <DsDropdownList
          className={`${this.variantStyles(hasBorder)} ${!hasBorder && 'ml-1'}`}
          initialId={this.state.timeFormatSelected}
          items={this.state.timeFormatOptions}
          onChange={(name) => this.props.onChange('timeFormat', name, destination, type)}
        />
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.renderThreeFields()}
      </div>
    );
  }
}

TimePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedTime: PropTypes.object.isRequired,
  className: PropTypes.string,
  roundtripSelector: PropTypes.string,
  destination: PropTypes.string,
  hasBorder: PropTypes.bool,
};

export default TimePicker;
